<template>
  <Modal v-model="showSessionPopup" @input="onModalInput">
    <p class="pb-2 text-xl font-medium leading-tight">
      {{ $t('popups.session.title') }}
    </p>
    <p class="pb-5 text-sm leading-tight xl:pb-8">
      {{ $t('popups.session.description') }}
    </p>
    <div class="flex justify-end">
      <Button
        @click.prevent="keepSessionAlive"
      >
        {{ $t('popups.session.keepAliveButton') }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import SessionPopup from '~app/psp/base/session-popup.ts'
import Button from '~brand-components/swiss/button/button.vue'
import Modal from '~brand-components/swiss/modal/modal.vue'

export default SessionPopup.extend({
  components: {
    Button,
    Modal,
  },
})
</script>
